var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table" }, [
    _c("table", [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function(column, index) {
            return _c("th", { key: index }, [
              _vm._v("\n          " + _vm._s(column.title) + "\n        ")
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "tr",
            { key: index },
            _vm._l(_vm.columns, function(column, colIndex) {
              return _c(
                "td",
                { key: index + "-" + colIndex },
                [[_vm._t(column.name, null, { rowData: item })]],
                2
              )
            }),
            0
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b51529b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b51529b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/BaseTable.vue
// module id = null
// module chunks = 